import {httpService, HttpWrapperOptions} from '../../../shared/httpWrapper';
import {AppThunk} from '..';
import {NewResponsePayloadSet, NewsResponsePayload} from '../../../shared/models/api';
import {apiUrls} from '../../../shared/constants/urls';
import {newsSlice} from '../../reducers/news';
import {getApiRoute} from '../../../shared/pipes/getApiRoute';
import {defaults} from '../../../shared/constants/defaults';
import {RequestNewsParams} from '../../../shared/models/news';

const requestNews = async (params?: RequestNewsParams | null) => {
  const {perPage, ...restParams} = params || {};
  const queryParams = {page: 1, 'per-page': perPage, ...restParams};
  return (await httpService.get<NewsResponsePayload[]>(getApiRoute(apiUrls.getNews, null, queryParams))) || [];
};

export const getLatestNews = (): AppThunk => async (dispatch) => {
  const perPage = defaults.newsPageSize;
  const response = await requestNews({page: 1, perPage});
  dispatch(newsSlice.actions.setLatestNews(response));
  dispatch(newsSlice.actions.setMoreNewsAvailable(response.length >= perPage));
};

export const getMoreNews = (): AppThunk => async (dispatch, getState) => {
  const {page, selection, from, to} = getState().news;
  const perPage = defaults.newsPageSize;
  const nextPage = page + 1;
  dispatch(newsSlice.actions.setPage(nextPage));
  const response = await requestNews({page: nextPage, from, to, perPage});
  dispatch(newsSlice.actions.setNews(selection.concat(response)));
  dispatch(newsSlice.actions.setMoreNewsAvailable(response.length >= perPage));
};

export const getNewsById =
  (id: number): AppThunk =>
  async (dispatch) => {
    const response = await httpService.get<NewResponsePayloadSet>(
      getApiRoute(apiUrls.getNewsById, {id}),
      new HttpWrapperOptions().Errors(false).ThrowException(true),
    );
    dispatch(newsSlice.actions.setNewsById(response));
  };

export const applyNewsFilter =
  (params: RequestNewsParams | null = null): AppThunk =>
  async (dispatch) => {
    const perPage = params?.perPage ?? defaults.newsPageSize;
    const response = await requestNews(params);
    dispatch(newsSlice.actions.setNews(response));
    dispatch(newsSlice.actions.setPage(1));
    dispatch(newsSlice.actions.setDateRange(params));
    dispatch(newsSlice.actions.setMoreNewsAvailable(response.length >= perPage));
  };
